import React, { useState, useEffect, useContext } from "react";
import ListInfo from "../../CourseInfo/Course/CourseInfoCreate.module.css";
import styles from "./StudentCouponCode.module.css";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import { UserContext } from "../../../../../context/UserDetails";
import { ImageUrlPrefix } from "../../../../../labels";
import { Download } from "@mui/icons-material";
import cartInfo from "../../../../Component/BackOffice/BookModule/AddToCart/AddToCart.module.css";
import toast from "react-hot-toast";

const StudentProfile = () => {
  const moment = require("moment-timezone");
  const [error, setError] = useState({});
  const [open, setOpen] = useState(false);
  const [isEditopen, setisEditopen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [initialfields, setInitialfields] = useState({
    deliveryMode: 1,
    name: "",
    phoneNumber: "",
    address: "",
    Pincode: "",
    EditID: "",
  });
  const { logout } = useContext(UserContext);
  const [userData, setUserData] = useState(null);
  const [delivery, setDelivery] = useState([]);
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    } else {
      logout();
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "name") {
      // Allow only letters and spaces
      const isValidName = /^[a-zA-Z\s]*$/.test(value);

      if (!isValidName) {
        setError((prevError) => ({
          ...prevError,
          name: "Only letters and spaces are allowed",
        }));
        return;
      }

      if (value.length > 250) {
        setError((prevError) => ({
          ...prevError,
          name: "Name should not exceed 250 characters",
        }));
        return;
      }

      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));

      setError((prevError) => ({
        ...prevError,
        name: "",
      }));

      return;
    }

    const numericValue = value.replace(/[^0-9]/g, "");

    if (name === "phoneNumber") {
      setInitialfields((prevList) => ({
        ...prevList,
        [name]: numericValue,
      }));

      if (numericValue.length === 10) {
        if (numericValue.startsWith("0")) {
          setError((prevError) => ({
            ...prevError,
            [name]: "Phone number should not start with 0",
          }));
        } else {
          setError((prevError) => ({
            ...prevError,
            [name]: "",
          }));
        }
      } else {
        setError((prevError) => ({
          ...prevError,
          [name]: "Please enter a valid 10 digit number",
        }));
      }
      return;
    }

    if (name === "Pincode") {
      setInitialfields((prevList) => ({
        ...prevList,
        [name]: numericValue,
      }));

      if (numericValue.length === 6 || numericValue.length === 0) {
        setError((prevError) => ({
          ...prevError,
          Pincode: "",
        }));
      } else {
        setError((prevError) => ({
          ...prevError,
          Pincode: "Please enter a valid 6-digit pincode",
        }));
      }
      return;
    }

    if (name === "deliveryMode") {
      setInitialfields({
        ...initialfields,
        deliveryMode: initialfields.deliveryMode === 1 ? 0 : 1,
      });
      return;
    }

    // Default input handler
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    }));
  };
  const validateERRORDEFields = (NAME, PHONENUMBER, ADDRESS, PINCODE) => {
    const errors = {};

    if ((NAME || "").trim() === "") {
      errors.name = "Please enter the name";
    }

    const phoneStr = (PHONENUMBER || "").toString().trim();
    if (phoneStr === "") {
      errors.phoneNumber = "Please enter the phone number";
    } else if (phoneStr.length !== 10) {
      errors.phoneNumber = "Please enter a valid 10 digit number";
    } else if (phoneStr.startsWith("0")) {
      errors.phoneNumber = "Phone number cannot start with 0";
    }

    if ((ADDRESS || "").trim() === "") {
      errors.address = "Please enter the address";
    }

    const pinStr = (PINCODE || "").toString().trim();
    if (pinStr === "") {
      errors.Pincode = "Please enter the pincode";
    } else if (pinStr.length !== 6) {
      errors.Pincode = "Please enter a valid 6-digit pincode";
    }

    return errors;
  };

  const handleAddressClose = () => {
    const errors = validateERRORDEFields(
      initialfields.name,
      initialfields.phoneNumber,
      initialfields.address,
      initialfields.Pincode
    );

    // If there are errors, set them and return early
    if (Object.keys(errors).length === 0) {
      const addAddress = {
        id: isEditopen ? initialfields.EditID : "",
        user_id: userid,
        name: initialfields.name,
        address: initialfields.address,
        phone_no: initialfields.phoneNumber,
        pincode: initialfields.Pincode,
        created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
        created_by: userid,
      };
      AxiosInstance.post("/api/book/cart/address/add", addAddress)
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message);
            handleModelClose();
            handleAddresslist(userid);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setError(errors);
    }
  };

  const handleAddresslist = (userId) => {
    if (!userId) {
      console.warn("User ID is missing. Skipping API call.");
      return;
    }

    AxiosInstance.post("/api/book/cart/address/list", { user_id: userId })
      .then((res) => {
        if (
          res.data.status &&
          Array.isArray(res.data.data) &&
          res.data.data.length > 0
        ) {
          // Sort by created_dt descending (newest first)
          const sortedData = res.data.data.sort(
            (a, b) => new Date(b.created_dt) - new Date(a.created_dt)
          );
          setDelivery(sortedData);
        } else {
          setDelivery([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching addresses:", error);
        setDelivery([]);
      });
  };

  useEffect(() => {
    if (userid) {
      handleAddresslist(userid);
    }
  }, [userid]);

  // profile function
  useEffect(() => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userId = user.user_id;
        setIsLoading(true);
        AxiosInstance.post(`api/course/admission/info_view/${userId}/0`)
          .then((response) => {
            if (response.data.status) {
              setIsLoading(false);
              const filteredEdu = response.data.data.edu?.filter(
                (entry) => entry.name?.trim() !== ""
              );
              setUserData({
                ...response.data.data,
                edu: filteredEdu,
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            setIsLoading(false);
          });
      }
    }
  }, []);

  const handleProfile = (id) => {
    navigate(`/EditProfile`);
  };
  const degreeOrder = [
    "SSLC",
    "HSC",
    "UG",
    "PG",
    "INTEGRATED PG",
    "DIPLOMA",
    "PROFESSIONAL COURSES",
    "OTHERS",
  ];

  const sortedEdu = [...(userData?.edu || [])].sort((a, b) => {
    if (a.qualification_type === "EDQ" && b.qualification_type === "EDQ") {
      const aIndex = degreeOrder.indexOf(a.name?.toUpperCase()) ?? Infinity;
      const bIndex = degreeOrder.indexOf(b.name?.toUpperCase()) ?? Infinity;
      return aIndex - bIndex;
    }
    if (a.qualification_type === "EDQ") return -1;
    if (b.qualification_type === "EDQ") return 1;
    return 0;
  });

  const handleModelClose = () => {
    setOpen(false);
    setError({
      ...error,
      name: "",
      phoneNumber: "",
      address: "",
      Pincode: "",
    });
  };

  const handleModelOpen = () => {
    setOpen(true);
    setisEditopen(false);
    setInitialfields((prevList) => ({
      ...prevList,
      name: "",
      phoneNumber: "",
      address: "",
      Pincode: "",
    }));
  };

  const handleEditAddress = (datads) => {
    setOpen(true);
    setisEditopen(true);

    const updatedFields = {
      delivery_mode: 1,
      EditID: datads.id,
      name: datads.name,
      phoneNumber: datads.phone_no,
      address: datads.address,
      Pincode: datads.pincode,
    };

    setInitialfields((prevList) => ({
      ...prevList,
      ...updatedFields,
    }));

    // Trigger validation immediately after setting values
    const errors = validateERRORDEFields(
      datads.name,
      datads.phone_no,
      datads.address,
      datads.pincode
    );

    setError(errors);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={`${ListInfo.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid BathHeader  global_container p-0`}
    >
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">Profile</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                // onClick={() => handleNavigate(id)}
                onClick={(e) => {
                  if (true) {
                    e.preventDefault();
                  } else {
                    handleProfile();
                  }
                }}
                className={`primaryButton ${
                  true ? "disabledbtn pointer-events-none opacity-50" : ""
                }`}
                variant="primary"
              >
                {" "}
                <span className="material-icons me-1 fs-5 align-middle text-white">
                  border_color
                </span>{" "}
                Edit Profile
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {/* ---------------------------------------------------------------- */}
      {/* Basic Details */}
      <fieldset className="mt-3" style={{ position: "relative" }}>
        <legend className="w-auto">Basic Details</legend>
        <div className="row">
          <div className="col-lg-9">
            <div className="row">
              {[
                { label: "First Name", value: userData?.first_name },
                { label: "Last Name", value: userData?.last_name },
                { label: "Father's Name", value: userData?.father_name },
                { label: "Mother's Name", value: userData?.mother_name },
                { label: "Date of Birth", value: userData?.dob?.split("T")[0] },
                { label: "Gender", value: userData?.gender },
                { label: "Age", value: userData?.age },
                { label: "Marital Status", value: userData?.marital_status },
              ].map((item, index) => (
                <div key={index} className="my-1 col-lg-4 col-md-4 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">{item.label}</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {item.value || "_"}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-12">
            <div className="position-relative text-center">
              {userData?.profile_path ? (
                <img
                  className={`${styles.ProfilePhoto} bg-opacity-75`}
                  src={`${ImageUrlPrefix}/${userData.profile_path}`}
                  alt="Profile"
                />
              ) : (
                <div
                  className={`${styles.ProfilePhoto} d-flex align-items-center justify-content-center bg-opacity-75`}
                >
                  <img
                    src="/images/default_profile.png"
                    alt=""
                    className="img-fluid"
                  />

                  <span id="text">Profile Picture</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </fieldset>

      <div className="row p-0">
        {/* ID Proofs */}
        <div className="mt-3 col-lg-6">
          <fieldset>
            <legend className="w-auto">ID Proofs</legend>
            <div className="col-md-12">
              <div className="row">
                {/* AADHAR Number */}
                <div className="col-lg-6 col-md-6 my-1">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center">
                      <span className="confirm_label m-0 p-0">
                        AADHAR Number
                      </span>
                    </div>
                    <p className="confirm_value my-1 m-0 p-0">
                      {userData?.aadhar_no || "_"}
                    </p>
                  </div>
                </div>

                {/* Upload AADHAR Card with download icon */}
                <div className="col-lg-6 col-md-6 my-1">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center">
                      <span className="confirm_label m-0 p-0">
                        Upload AADHAR Card
                      </span>
                      {userData?.original_aadhar_path && (
                        <a
                          href={`${ImageUrlPrefix}/${userData.aadhar_path}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                          className="ms-2"
                        >
                          <span className="material-icons download_icon align-middle text-danger">
                            file_download
                          </span>
                        </a>
                      )}
                    </div>
                    {userData?.original_aadhar_path ? (
                      <p className="confirm_value my-1 m-0 p-0">
                        {userData.original_aadhar_path}
                      </p>
                    ) : (
                      <p className="confirm_value my-1 m-0 p-0">_</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        {/* Communal Reservation Category */}
        <div className="mt-3 col-lg-6">
          <fieldset>
            <legend className="w-auto">Communal Reservation Category</legend>
            <div className="row">
              <div className="col-lg-6 col-md-6 my-1">
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <span className="confirm_label m-0 p-0">Category</span>
                  </div>
                  <p className="confirm_value my-1 m-0 p-0">
                    {userData?.community || "_"}
                  </p>
                </div>
              </div>

              {/* Upload community with download icon */}
              <div className="col-lg-6 col-md-6 my-1">
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <span className="confirm_label m-0 p-0">
                      Upload Community Certificate
                    </span>
                    {userData?.original_caste_path && (
                      <a
                        href={`${ImageUrlPrefix}/${userData.community_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                        className="ms-2"
                      >
                        <span className="material-icons download_icon align-middle text-danger">
                          file_download
                        </span>
                      </a>
                    )}
                  </div>
                  {userData?.original_caste_path ? (
                    <p className="confirm_value my-1 m-0 p-0">
                      {userData.original_caste_path}
                    </p>
                  ) : (
                    <p className="confirm_value my-1 m-0 p-0">_</p>
                  )}
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      {/* Contact Details */}
      <fieldset className="mt-3">
        <legend className="w-auto">Contact Details</legend>
        <div className="row">
          {[
            { label: "Phone Number", value: userData?.phone_no },
            {
              label: "WhatsApp Number",
              value:
                userData?.ContactNumber === true
                  ? userData?.phone_no
                  : userData?.whatsapp_no || "-",
            },
            {
              label: "Father/Guardian Phone Number",
              value: userData?.parent_mob_no || "-",
            },
            { label: "Email ID", value: userData?.email },
          ].map((item, index) => (
            <div key={index} className="col-lg-3 col-md-6 my-1">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0">{item.label}</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {item.value || "_"}
                </p>
              </div>
            </div>
          ))}
        </div>
      </fieldset>
      {/* Address */}
      <div className="row p-0">
        {Array.isArray(userData?.address) && userData.address.length > 0 ? (
          userData.address.map((addr, idx) => {
            const isEmptyAddress =
              !addr.address1 &&
              !addr.address2 &&
              !addr.address3 &&
              !addr.landmark &&
              !addr.taluk &&
              !addr.post_name &&
              !addr.postal_code &&
              !addr.city &&
              !addr.district_name &&
              !addr.state_name;

            return (
              <div key={idx} className="mt-3 col-lg-6">
                <fieldset>
                  <legend className="w-auto">
                    {addr.address_type === 1
                      ? "Present Address"
                      : "Permanent Address"}
                  </legend>
                  {isEmptyAddress ? (
                    <p className="text-center mb-0 mt-2">
                      No records to display
                    </p>
                  ) : (
                    <div className="d-flex flex-column">
                      {[
                        [addr.address1, addr.address2],
                        [addr.address3, addr.landmark],
                        [addr.taluk, addr.post_name],
                        [addr.postal_code, addr.city],
                        [addr.district_name, addr.state_name],
                      ].map((pair, index) => {
                        const value = pair.filter(Boolean).join(", "); // Remove falsy and join with comma
                        return value ? (
                          <div key={index} className="mb-2">
                            <p className="confirm_value my-1 m-0 p-0">
                              {value}
                            </p>
                          </div>
                        ) : null;
                      })}
                    </div>
                  )}
                </fieldset>
              </div>
            );
          })
        ) : (
          <div className="col-12 mt-3">
            <p className="text-muted">No addresses found</p>
          </div>
        )}
      </div>

      {/* educations */}
      {Array.isArray(userData?.edu) && userData.edu.length > 0 ? (
        <>
          {/* Separate "EDQ" and "THQ" fieldsets */}
          {sortedEdu.map((qualification, index) => {
            const isEDQ = qualification.qualification_type === "EDQ";
            const name = qualification?.name?.toUpperCase();

            const fields = isEDQ
              ? name === "SSLC" || name === "HSC"
                ? [
                    {
                      label: "Certificate Number",
                      value: qualification?.certificate_no || "-",
                    },
                    {
                      label: "Year of Passing",
                      value: qualification?.year_of_passing || "-",
                    },
                    {
                      label: "Marks Percentage",
                      value: qualification?.marks_percentage
                        ? `${qualification.marks_percentage}%`
                        : "-",
                    },
                    {
                      label: "Education Board",
                      value: qualification?.edu_board || "-",
                    },
                    {
                      label: "Medium of Instruction",
                      value: qualification?.edu_medium || "-",
                    },
                    {
                      label: "School Name",
                      value: qualification?.institute || "-",
                    },
                  ]
                : [
                    {
                      label: "Certificate Number",
                      value: qualification?.certificate_no || "-",
                    },
                    {
                      label: "Year of Passing",
                      value: qualification?.year_of_passing || "-",
                    },
                    {
                      label: "Degree",
                      value: qualification?.degree_name || "-",
                    },
                    {
                      label: "Major",
                      value: qualification?.major_subject || "-",
                    },
                    {
                      label: "Marks Percentage",
                      value: qualification?.marks_percentage
                        ? `${qualification.marks_percentage}%`
                        : "-",
                    },
                    { label: "Class", value: qualification?.grade || "-" },
                    {
                      label: "Name of Institute",
                      value: qualification?.institute || "-",
                    },
                  ]
              : [
                  {
                    label: "Technical Course",
                    value: qualification?.name || "-",
                  },
                  {
                    label:
                      qualification.name === "Steno"
                        ? "Stenographer Level"
                        : qualification.name === "COA"
                        ? "Computer Office Automation"
                        : qualification.name === "Knowledge in computer" ||
                          qualification.name === "Others"
                        ? "Course In Computer"
                        : "Typewriting Level",
                    value: qualification?.level || "-",
                  },
                  {
                    label: "Language",
                    value: qualification?.edu_medium || "-",
                  },
                  {
                    label: "Certificate Number",
                    value: qualification?.certificate_no || "-",
                  },
                  { label: "Grade", value: qualification?.grade || "-" },
                  {
                    label: "Year of Passing",
                    value: qualification?.year_of_passing || "-",
                  },
                ];

            return (
              <fieldset className="mt-3" key={index}>
                <legend className="w-auto">
                  {qualification?.name.toUpperCase() || "Education Details"}
                </legend>
                <div className="row">
                  {fields.map((item, i) => (
                    <div key={i} className="col-lg-3 col-md-6 my-1">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">{item.label}</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {item.value}
                        </p>
                      </div>
                    </div>
                  ))}

                  {/* Upload Certificate - Common */}
                  <div className="col-lg-3 col-md-6 my-1">
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center">
                        <span className="confirm_label m-0 p-0">
                          Upload Certificate
                        </span>
                        {qualification?.original_file_path && (
                          <a
                            href={`${ImageUrlPrefix}/${qualification.certificate_path}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            className="ms-2"
                          >
                            <span className="material-icons download_icon align-middle text-danger">
                              file_download
                            </span>
                          </a>
                        )}
                      </div>
                      <p className="confirm_value my-1 m-0 p-0">
                        {qualification?.original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </fieldset>
            );
          })}
        </>
      ) : (
        <fieldset className="mt-3">
          <legend className="w-auto">Educational Qualification</legend>
          <p className="text-center mb-0 mt-2">No records to display</p>
        </fieldset>
      )}
      {/* Delivery address */}
      <div>
        <fieldset className="mt-3">
          <legend className="w-auto">Delivery Address</legend>
          <div className="col-md-12 col-12 ListBtn borderWidth_profile">
            <ul class="List-Button mt-2">
              <li class="ListBtnItems">
                <Link
                  onClick={() => handleModelOpen()}
                  to="#exampleModalLabel"
                  className="primaryButton "
                >
                  Add New Delivery Address
                </Link>
              </li>
            </ul>
          </div>
          <div className="">
            {delivery.length > 0 ? (
              delivery.map((io) => (
                <div
                  key={io.id}
                  className="ulFilterListData d-flex borderWidth_profile"
                >
                  <div className="filterListData col-md-6">
                    <div>
                      <div>
                        <label className={styles.confirm_address_value}>
                          {io.name} - {io.phone_no}
                        </label>
                      </div>
                      <div>
                        <label className={styles.confirm_address_value}>
                          {io.address}
                        </label>
                      </div>
                      <div>
                        <label className="confirm_value">{io.pincode}</label>
                      </div>
                    </div>
                  </div>
                  <div class={` ${cartInfo.editAddress} ListBtnItems col-md-6`}>
                    <Link
                      to="javascript:void(0)"
                      onClick={() => handleEditAddress(io)}
                      className="primaryButton"
                      variant="primary"
                    >
                      {" "}
                      <span className="material-icons me-1 fs-5 align-middle text-white">
                        border_color
                      </span>{" "}
                      Edit Address
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center mb-0 mt-2">No records to display</p>
            )}
          </div>
        </fieldset>
      </div>

      {open && (
        <Modal
          key={`modal-0-${0}`}
          show={open}
          onHide={handleModelClose}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h5
                className={`${cartInfo.view_title} fw-bold mb-0`}
                id="exampleModalLabel"
              >
                {isEditopen ? "Edit Address" : "Add New Delivery Address"}
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <></>
            <div className="row global_container">
              <div className="col-12">
                <form className="row g-3">
                  {/* Evaluator Name Dropdown */}
                  <div className="col-md-6">
                    <label for="name" class="form-label confirm_value ">
                      Name
                    </label>
                    <input
                      // ref={course_ref}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                      type="text"
                      id="Name"
                      name="name"
                      placeholder="Enter the name"
                      value={initialfields.name}
                      onChange={handleChange}
                    />
                    {error.name && (
                      <small className="error_message">{error.name}</small>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label for="phoneNumber" class="form-label confirm_value ">
                      Phone Number
                    </label>
                    <input
                      // ref={course_ref}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                      type="text"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="Enter the phone number"
                      value={initialfields.phoneNumber}
                      onChange={handleChange}
                    />
                    {error.phoneNumber && (
                      <small className="error_message">
                        {error.phoneNumber}
                      </small>
                    )}
                  </div>

                  <div className="col-md-12">
                    <label for="address" class="form-label confirm_value ">
                      Address
                    </label>
                    <textarea
                      // ref={subject_ref}
                      className={`${cartInfo.desc_input} w-100 rounded p-2 input-font-size`}
                      placeholder="Enter the address"
                      id="address"
                      onChange={(e) => handleChange(e)}
                      value={initialfields.address}
                      name="address"
                      maxLength={500}
                      style={{
                        height: "auto",
                        // minHeight: "calc(24px * 8)",
                      }}
                    ></textarea>
                    {error.address && (
                      <small className="error_message">{error.address}</small>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label for="Pincode" class="form-label confirm_value ">
                      Pincode
                    </label>
                    <input
                      // ref={course_ref}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                      type="text"
                      id="pincode"
                      name="Pincode"
                      placeholder="Enter the pincode"
                      value={initialfields.Pincode}
                      onChange={handleChange}
                    />
                    {error.Pincode && (
                      <small className="error_message">{error.Pincode}</small>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link onClick={handleAddressClose} className="primaryButton">
                  {isEditopen ? "Update Now" : "Add Now"}
                </Link>
              </li>
            </ul>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default StudentProfile;
